import SliderModel from '../Apis/Slider.js'
import Controller from './Controller.js';

export default class SliderController extends Controller {

    constructor() {
        super(new SliderModel());
    }


}